module.exports = __webpack_public_path__ + "static/media/timer-2.b096c115.svg";